module.exports = __webpack_public_path__ + "static/media/eatwellimage.396da936.png";